// Mix topic images for default topics
import CivicsImage from "../../../../images/learner/mixTopics/civics.png";
import CodingImage from "../../../../images/learner/mixTopics/coding.png";
import CommunicationImage from "../../../../images/learner/mixTopics/communication.png";
import EconomicsImage from "../../../../images/learner/mixTopics/economics.png";
import EngineeringImage from "../../../../images/learner/mixTopics/engineering.png";
import FoodImage from "../../../../images/learner/mixTopics/food.png";
import ForeignLanguageImage from "../../../../images/learner/mixTopics/foreign-language.png";
import GamingImage from "../../../../images/learner/mixTopics/gaming.png";
import GeographyImage from "../../../../images/learner/mixTopics/geography.png";
import HealthImage from "../../../../images/learner/mixTopics/health.png";
import HistoryImage from "../../../../images/learner/mixTopics/history.png";
import LifeSkillsImage from "../../../../images/learner/mixTopics/life-skills.png";
import MathImage from "../../../../images/learner/mixTopics/math.png";
import MusicImage from "../../../../images/learner/mixTopics/music.png";
import NatureImage from "../../../../images/learner/mixTopics/nature.png";
import PerformingArtsImage from "../../../../images/learner/mixTopics/performing-arts.png";
import PhilosophyImage from "../../../../images/learner/mixTopics/philosophy.png";
import PsychologyImage from "../../../../images/learner/mixTopics/psychology.png";
import ReadingImage from "../../../../images/learner/mixTopics/reading.png";
import ScienceImage from "../../../../images/learner/mixTopics/science.png";
import SocialStudiesImage from "../../../../images/learner/mixTopics/social-studies.png";
import SportsImage from "../../../../images/learner/mixTopics/sports.png";
import TechnologyImage from "../../../../images/learner/mixTopics/technology.png";
import VisualArtImage from "../../../../images/learner/mixTopics/visual-art.png";
import WritingImage from "../../../../images/learner/mixTopics/writing.png";

export enum TopicFilter {
  All = "All",
  MyMixes = "My Mixes",
  DefaultTopics = "Default Topics",
}

export type DefaultTopic = {
  uid: string;
  title: string;
  description: string;
  attachmentUrl: string;
};

export type Topic = DefaultTopic & {
  isDefault: boolean;
};

export const DEFAULT_TOPIC_IMAGES: Record<string, string> = {
  civics: CivicsImage,
  coding: CodingImage,
  communication: CommunicationImage,
  economics: EconomicsImage,
  engineering: EngineeringImage,
  food: FoodImage,
  "foreign-languages": ForeignLanguageImage,
  gaming: GamingImage,
  geography: GeographyImage,
  health: HealthImage,
  history: HistoryImage,
  "life-skills": LifeSkillsImage,
  math: MathImage,
  music: MusicImage,
  nature: NatureImage,
  "performing-arts": PerformingArtsImage,
  philosophy: PhilosophyImage,
  psychology: PsychologyImage,
  reading: ReadingImage,
  science: ScienceImage,
  "social-studies": SocialStudiesImage,
  sports: SportsImage,
  technology: TechnologyImage,
  "visual-art": VisualArtImage,
  writing: WritingImage,
};
